/** KAN-718: журнал писем (список с фильтрами и одно письмо с телом). */
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { emailsApi } from '@/services/api/emails';
import type { EmailListParams } from '@/types/emailMailbox';

export const EMAILS_QUERY_KEY = ['emails'] as const;

export function useEmails(params: EmailListParams) {
  return useQuery({
    queryKey: [...EMAILS_QUERY_KEY, params],
    queryFn: () => emailsApi.list(params),
    placeholderData: keepPreviousData,
    staleTime: 15_000,
  });
}

export function useEmail(id: string | null) {
  return useQuery({
    queryKey: [...EMAILS_QUERY_KEY, 'detail', id],
    queryFn: () => emailsApi.get(id as string),
    enabled: !!id,
  });
}
